import { render, staticRenderFns } from "./teams-tab.vue?vue&type=template&id=b2942324"
import script from "./teams-tab.vue?vue&type=script&lang=js"
export * from "./teams-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports